export const BILLING_DOMAIN_CREATE = 'CLOUD_SUBSCRIPTIONS/DOMAIN/CREATE_NOTIFICATION/TRIGGER';

export const BILLING_OPEN_MODAL = 'BILLING_PURCHASE_MODAL/TRIGGER';

export const openBillingModal = (params: {
    successRedirectUrl?: string;
    fallbackRedirectUrl?: string;
    qty?: number;
    term?: string;
    currency?: string;
    actionSource:
        | 'EDIT_SUBSCRIPTION'
        | 'MY_SUBSCRIPTIONS'
        | 'PRE_ONBOARDING'
        | 'PRE_ONBOARDING_AUTO_WEBSITE';
}) => ({
    type: BILLING_OPEN_MODAL,
    payload: params,
});
